import { css } from 'styled-components';
import { lg } from '@exonet/react-shared/lib/styled';

export default css`
  body,
  html {
    font-family: var(--font-family-2);
    font-size: var(--font-size);
    color: var(--text);
    line-height: var(--line-height);
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-family: var(--font-family);
    color: var(--title-text);

    & + p {
      margin-top: 0;
    }
  }

  h1 {
    font-size: 1.3em;
  }

  h2 {
    font-size: 1.15em;
    margin-bottom: 0;
  }

  h3 {
    margin-bottom: 0;
    font-size: 1em;
  }

  h4 {
    font-weight: 700;
    font-family: var(--font-family-2);
  }

  h5 {
    font-family: var(--font-family-2);
  }

  p {
    line-height: calc(var(--line-height) * 1.25);
  }

  input,
  textarea,
  button {
    font-family: var(--font-family-2);
    line-height: var(--line-height);
  }

  a {
    &,
    &:active,
    &:visited {
      color: var(--link);
      font-weight: normal;
      user-select: text;
      text-decoration: none;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        bottom: -2px;
        right: 0;
        width: 0;
        height: 1px;
        background-color: var(--link-hover);
        transition: width 0.3s cubic-bezier(0.25, 1, 0.5, 1);
      }
    }

    &:hover {
      color: var(--link-hover);

      &::before {
        left: 0;
        right: auto;
        width: 100%;
      }
    }
  }

  strong {
    color: var(--text-strong);
  }

  label {
    > span {
      color: var(--text-strong, var(--text));
    }
  }

  .lead {
    font-size: var(--lg-font-size);
    letter-spacing: 0.4em;
    line-height: var(--line-height);
    text-align: center;
    word-break: break-word;
  }

  input:focus,
  select:focus,
  textarea:focus,
  button:focus,
  input[type='checkbox']:focus,
  input[type='checkbox']:focus-visible,
  input[type='radio']:focus {
    outline: 1px solid var(--focus-ring-color);
    outline-offset: -1px;
    box-shadow: none;
    z-index: 100;
  }

  input[type='checkbox']:focus + label:after {
    outline: 1px solid var(--focus-ring-color);
    outline-offset: -1px;
    box-shadow: none;
    z-index: 100;
  }

  ${lg(css`
    h1 {
      font-size: 1.5em;
      margin-top: 0;
    }
  `)}
`;
